import HomeWhyChooseUs from "../home/HomeWhyChooseUs";

const SolutionsWhyChoose = () => {
  return (
    <div className="solutions-why-choose">
      <HomeWhyChooseUs />
    </div>
  );
};

export default SolutionsWhyChoose;
